// extracted by mini-css-extract-plugin
export default {"container":"hg-settings-wrapper_container__46vc5"};